export enum Feature {
  ADDITIONAL_LANGS_ES_PT = 'additional-langs-es-pt',
  EMPLOYER_PORTAL = 'employer-portal',
  FORMS_IMPROVEMENTS = 'forms_improvements',
  FORMS_V3_DEFAULT_QUESTIONS = 'forms-v3-default-questions',
  HIDE_INTERCOM = 'hide-intercom',
  RECRUITER_OUTREACH = 'recruiter-outreach',
  WORK_RECOMMENDER_V2 = 'work-recommender-v2',
  WORK_RECOMMENDER_V2_BEST_MATCH_SORT = 'work_recommender_v2_best_match_sort',
  WORK_RECOMMENDER_V2_LANDING_PAGE = 'work_recommender_v2_landing_page',
  WORK_RECOMMENDER_RELEVANT_AND_RELATED = 'work_rec_relevant_related',
  LLM_RESUME_SERVICE = 'llm_resume_service',
  LANGUAGE_FILTER = 'language_filter',
  LOOKER_INSIGHTS = 'looker_insights',
  LEARNING_SIDE_PANEL_SKILLS_AND_CAREERS = 'learning_side_panel_skills_and_careers',
  INVITE_LINKS_VALIDATE_EMAIL_DOMAINS = 'invite_links_validate_email_domains',
  HIDE_CAREER_DEMAND = 'hide_career_demand',
  ATS_EASY_APPLY = 'enable_ats_easy_apply',
  POLICY_DISPLAY_SIGN_UP = 'policy_display_sign_up',
  LEARNING_RESOURCE_HIDE_COST_FILTER = 'learning_resource_hide_cost_filter',
  USE_LLM_PARSED_SKILLS = 'use_llm_parsed_skills',
  ROLE_BASED_PERMISSIONS = 'role_based_permissions',
  SATISFACTION_RATINGS = 'satisfaction_ratings',
  ONBOARDING_SIMPLIFICATION = 'onboarding_simplification',
  LIVE_TRANSLATION = 'live_translation',
  CAREER_RECS_BY_CAREER_INTEREST = 'career-recs-by-career-interests',
  MANAGE_SKILLS_PER_WORK_EXPERIENCE = 'manage-skills-per-work-experience',
  WORK_CONFIGURATION = 'work_configuration',
  CREDENTIALS_UPDATE = 'credentials_update',
  LIVE_LMI_DATA = 'live_lmi_data',
  EDUCATION_TALENT_FILTERS = 'education_talent_filters',
  MANAGE_CONTENT = 'manage_content',
  ALLOW_RESTRICT_NEXT_STEP_BY_TAGS = 'allow_restrict_next_step_by_tags',
  BUSINESS_RESOURCES = 'business_resources',
  COURSE_LLM_GUARDRAILS = 'course_llm_guardrails',
  PARENT_CREDENTIALS_FILTER = 'parent_credentials_filter',
  CANDIDATE_RECOMMENDER_GUARDRAIL = 'candidate_recommender_guardrail',
  FEATURE_INDIVIDUAL_JOB = 'feature_individual_job',
  HOMEPAGE_V2 = 'homepage_v2',
  DOWNVOTE_RECOMMENDATIONS = 'downvote_recommendations',
  COURSES_ATLAS_SEARCH = 'courses_atlas_search',
  RESOURCES_ATLAS_SEARCH = 'resources_atlas_search',
  HOMEPAGE_V2_IMAGES = 'homepage_v2_images',
  SEARCH_JOBS_V3 = 'search_jobs_v3',
  SEARCH_JOBS_V3_FIND_JOBS = 'search_jobs_v3_find_jobs',
  FEATURED_EMPLOYER = 'featured-employer',
  JOB_TOOLS = 'job_tools',
  CANDIDATE_RECOMMENDER_REDESIGN = 'candidate-recommender-redesign',
  REDUCED_JOB_SEARCH_LIMIT = 'reduced_job_search_limit',
  SKILLS_ATLAS_SEARCH = 'skills_atlas_search',
  HOMEPAGE_PERSONA_ORDERING = 'homepage_persona_ordering',
  TALENT_RADIUS_FILTER = 'talent_radius_filter',
  INTERVIEW_PREP = 'interview_prep',
}
